import SlimSelect from 'slim-select'

export default class Contact {

  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.contact--form')
    if (!this.form) return

    this.mailer = this.form.dataset.mailer
    this.slimInstances = []

    this.initSlimSelect()
    this.bindCheckboxes()
    this.bindSubmit()
  }

  initSlimSelect() {
    const textarea = this.form.querySelector('.contact--textarea')

    const placeholders = {
      bootfitting: 'Précisez vos disponibilités pour la mise en place d\'une session de bootfitting.',
    }

    const updatePlaceholder = (value) => {
      if (textarea) textarea.placeholder = placeholders[value] || ''
    }

    this.form.querySelectorAll('.contact--select').forEach(select => {
      const cookieKey = `contact-select-${select.name || select.id || 'default'}`

      const instance = new SlimSelect({
        select,
        settings: {
          closeOnSelect: false,
          showSearch: true,
          searchPlaceholder: 'Rechercher...',
          searchText: 'Aucun résultat',
          searchHighlight: true,
          allowDeselect: true,
        },
        events: {
          afterChange: (selected) => {
            const values = selected.map(s => s.value).filter(Boolean)
            updatePlaceholder(values[0] || '')
            this.setCookie(cookieKey, values.join(','), 30)
          }
        }
      })

      this.slimInstances.push({ instance, cookieKey })

      const ssContent = instance.render?.content?.main instanceof Element
        ? instance.render.content.main
        : document.querySelector('.ss-content:not([data-lenis-prevent])')
      if (ssContent) ssContent.setAttribute('data-lenis-prevent', '')

      // Hash supporte plusieurs valeurs séparées par virgule : #Affutage,Fartage
      const hash = window.location.hash.replace('#', '')
      const cookieValue = this.getCookie(cookieKey)
      const fromHash = hash ? hash.split(',').map(v => decodeURIComponent(v.trim())) : []
      const fromCookie = cookieValue ? cookieValue.split(',') : []
      const initial = fromHash.length ? fromHash : fromCookie
      const normalize = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      const matches = initial.flatMap(v => {
        const match = [...select.options].find(opt => normalize(opt.value) === normalize(v))
        return match ? [match.value] : []
      })
      if (matches.length) instance.setSelected(matches)

      updatePlaceholder(instance.getSelected()[0] || '')
    })
  }

  resetSlimInstances() {
    this.slimInstances.forEach(({ instance, cookieKey }) => {
      instance.setSelected([])
      this.setCookie(cookieKey, '', -1)
    })
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
  }

  getCookie(name) {
    return document.cookie.split('; ').reduce((acc, c) => {
      const [k, v] = c.split('=')
      return k === name ? decodeURIComponent(v) : acc
    }, '')
  }

  bindCheckboxes() {
    this.el.querySelectorAll('.contact--checkbox-container').forEach(container => {
      container.addEventListener('click', (e) => {
        const checkbox = container.querySelector('.contact--input-checkbox')
        if (e.target !== checkbox) {
          checkbox.checked = !checkbox.checked
        }
      })
    })
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam && amispam.value) {
        console.error('Oh no ! I m Spam')
        return
      }

      const formData = new FormData(this.form)

      this.setState('loading')

      fetch(this.mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok')
          return response
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.setState('sent')
          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
            this.resetSlimInstances()
          }, 5000)
        })
    })

    this.form.querySelectorAll('.contact--btn.is-loading, .contact--btn.is-sent').forEach(btn => {
      btn.addEventListener('click', e => e.preventDefault())
    })
  }

  setState(state) {
    this.form.querySelectorAll('.contact--btn').forEach(btn => btn.classList.remove('is-active'))
    const target = this.form.querySelector(`.contact--btn.is-${state}`)
    if (target) target.classList.add('is-active')
  }

}
